const supplierManagementPageStyle = {
  root: {
    flexGrow: 1,
    display: 'flex',
    height: '100%',
    marginTop: '30px',
    marginBottom: '200px',
  },
  componentPanel: {
    marginRight: '100px',
  },
}

export default supplierManagementPageStyle
